import { groupBy, uniqBy, orderBy } from 'lodash';

import { DOT_LG } from 'constants/placeholders';
import { IdName } from 'interfaces/IdName';
import {
  IMarket,
  IMicromarket,
  ISubmarket,
  ISubmarketShapeGroup,
} from 'interfaces/IMarket';

export const convertIMarketIntoIdName = (market: IMarket): IdName => ({
  id: market.id,
  name: market.name,
});

export const getUniqueSubmarketsByName = (submarkets: ISubmarket[]) => {
  const submarketsByMarket = groupBy(submarkets, 'shapeGroup');
  let uniqSubmarkets: any = [];
  Object.keys(submarketsByMarket).forEach(marketKey => {
    uniqSubmarkets = [
      ...uniqSubmarkets,
      ...uniqBy(submarketsByMarket[marketKey], 'name'),
    ];
  });

  return uniqSubmarkets;
};

export const getSubmarketsByMarketNameShapeGroup = (
  submarkets: ISubmarket[] = [],
) => {
  const submarketsByMarketNameShapeGroup: ISubmarketShapeGroup[] = [];
  submarkets.forEach(submarket => {
    submarketsByMarketNameShapeGroup.push({
      ...submarket,
      marketNameShapeGroup: `${submarket.market?.name} ${DOT_LG} ${submarket.shapeGroup}`,
    });
  });
  return orderBy(submarketsByMarketNameShapeGroup, ['marketNameShapeGroup']);
};

export const getUniqueMicromarketsByName = (micromarkets: IMicromarket[]) => {
  return uniqBy(micromarkets || [], 'name');
};

export const getAvgMarketSubmarketAskingRent = (data: any[]) => {
  // Proper types should be used instead of 'any'. This might be implemented in #32280.
  return data.filter(d => d.className === 'ALL');
};
